export default {
    transclude: {'slot': '?transcludeSlot'},
    template: require("./top.bar.html"),
    bindings: {title: "@", hideSubMenu: "<"}
}
